import {
    AlertIcons,
    AlertSeverity,
} from '@perpay-web/components/base/Alert/Alert';
import {
    OVERPAYMENT,
    UPDATE_DIRECT_DEPOSIT,
} from '@perpay-web/fintech/constants/alertCtaTypes';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { formatCurrency } from '@perpay-web/utils/stringUtils';

/**
 * @knipignore Exported for testing only
 */
export const DELINQUENT_CARD_AND_MP = 'platform_delinquent';
/**
 * @knipignore Exported for testing only
 */
export const CHARGED_OFF = 'platform_charged_off';
export const PLATFORM_GOOD = 'platform_good';
export const PLATFORM_OVERPAYMENT = 'platform_overpayment';

export const EMPTY_NOTIFICATION = {
    content: '',
    severity: '',
    callToActionRoute: '',
    icon: '',
};

export const getMissedPaymentContent = (perpayPlus = false) =>
    `You missed your scheduled payment.${
        perpayPlus ? ' Your credit score may be impacted.' : ''
    }`;

const getPlatformNotificationsLevel1Map = (perpayPlus = false) => ({
    [DELINQUENT_CARD_AND_MP]: {
        content: getMissedPaymentContent(perpayPlus),
        severity: AlertSeverity.DANGER,
        callToActionRoute: paths.updateDirectDeposit.path,
        callToActionType: UPDATE_DIRECT_DEPOSIT,
        icon: '',
    },
    [CHARGED_OFF]: {
        content: getMissedPaymentContent(perpayPlus),
        severity: AlertSeverity.DANGER,
        callToActionRoute: paths.updateDirectDeposit.path,
        callToActionType: UPDATE_DIRECT_DEPOSIT,
        icon: '',
    },
    [PLATFORM_OVERPAYMENT]: {
        content: (overpaymentAmount) =>
            `We received a direct deposit ${formatCurrency(overpaymentAmount, true, false)} over your minimum. Withdraw your funds now.`,
        severity: 'warning',
        callToActionType: OVERPAYMENT,
        icon: AlertIcons.DOUBLE_EXCLAMATION,
        isRightArrow: true,
    },
});

const getPlatformNotificationsLevel2Map = (perpayPlus = false) => ({
    [DELINQUENT_CARD_AND_MP]: {
        content: getMissedPaymentContent(perpayPlus),
        severity: 'danger',
        callToActionRoute: paths.updateDirectDeposit.path,
        callToActionType: UPDATE_DIRECT_DEPOSIT,
        icon: AlertIcons.POLICE_CAR_LIGHT,
    },
    [CHARGED_OFF]: {
        content: getMissedPaymentContent(perpayPlus),
        severity: 'danger',
        callToActionRoute: paths.updateDirectDeposit.path,
        callToActionType: UPDATE_DIRECT_DEPOSIT,
        icon: AlertIcons.POLICE_CAR_LIGHT,
    },
});

export const PLATFORM_NOTIFICATIONS_LEVEL_1_MAP =
    getPlatformNotificationsLevel1Map(false);

export const PLATFORM_NOTIFICATIONS_LEVEL_2_MAP =
    getPlatformNotificationsLevel2Map(false);

export const PLATFORM_NOTIFICATIONS_LEVEL_1_MAP_WITH_PERPAY_PLUS =
    getPlatformNotificationsLevel1Map(true);

export const PLATFORM_NOTIFICATIONS_LEVEL_2_MAP_WITH_PERPAY_PLUS =
    getPlatformNotificationsLevel2Map(true);
